import moment from "moment";

export const saveDateTime = (date, name) => {
  localStorage.setItem(`${name}`, date);
};
export const lessThanOneHourAgo = (date) =>
  moment(date).add(1, "hours").isAfter(moment());
